import  { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import api from '../services/api';
import './Dashboard.css'; // ✅ Dashboard styles

const Dashboard = () => {
  const [summary, setSummary] = useState({
    totalBookings: 0,
    totalCustomers: 0,
    pendingShipments: 0,
  });

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const bookingsRes = await api.get('/bookings');
        const customersRes = await api.get('/customers');

        const totalBookings = bookingsRes.data.length;
        const totalCustomers = customersRes.data.length;
        const pendingShipments = bookingsRes.data.filter(b => b.status === 'Pending').length;

        setSummary({ totalBookings, totalCustomers, pendingShipments });
      } catch (error) {
        console.error('Failed to fetch dashboard summary:', error);
      }
    };

    fetchSummary();
  }, []);

  return (
    <div>
      <Navbar />
      <div className="dashboard-container">
        <h1>Welcome to Logistics Dashboard</h1>

        <div className="card-grid">
          <div className="card">
            <h3>Total Bookings</h3>
            <p>{summary.totalBookings}</p>
          </div>
          <div className="card">
            <h3>Total Customers</h3>
            <p>{summary.totalCustomers}</p>
          </div>
          <div className="card">
            <h3>Pending Shipments</h3>
            <p>{summary.pendingShipments}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
